import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiGlobe, FiLock, FiShield } from 'react-icons/fi';
import './Footer.css';
import { useLanguage } from '../i18n/LanguageContext';

const trustItems = {
  en: [
    { icon: FiShield, title: 'PIPEDA aligned', subtitle: 'Health data protected' },
    { icon: FiLock, title: 'Secure payments', subtitle: 'Encrypted transactions' },
    { icon: FiCheckCircle, title: 'Verified providers', subtitle: 'Credentials reviewed' },
    { icon: FiGlobe, title: 'Multilingual care', subtitle: 'Inclusive access' }
  ],
  fr: [
    { icon: FiShield, title: 'Conformité PIPEDA', subtitle: 'Protection des données' },
    { icon: FiLock, title: 'Paiements sécurisés', subtitle: 'Transactions chiffrées' },
    { icon: FiCheckCircle, title: 'Prestataires vérifiés', subtitle: 'Certifications validées' },
    { icon: FiGlobe, title: 'Service multilingue', subtitle: 'Accès inclusif' }
  ]
};

function Footer() {
  const { language } = useLanguage();
  const copy = trustItems[language] || trustItems.en;

  return (
    <footer className="km-footer">
      <div className="km-footer__trust">
        <div className="km-page-shell km-footer__trust-grid">
          {copy.map(({ icon: Icon, title, subtitle }) => (
            <div className="km-footer__trust-item" key={title}>
              <span className="km-footer__trust-icon">
                <Icon />
              </span>
              <strong>{title}</strong>
              <span>{subtitle}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="km-page-shell km-footer__main">
        <div className="km-footer__brand">
          <Link className="km-footer__logo" to="/">KnowMediQ</Link>
          <p>
            {language === 'fr'
              ? 'Construire une infrastructure de soins plus humaine, plus rapide et plus coordonnée pour les familles canadiennes.'
              : 'Building a more human, coordinated, and responsive care experience for Canadian families.'}
          </p>
        </div>

        <div className="km-footer__columns">
          <div>
            <h5>{language === 'fr' ? 'Pour les familles' : 'For families'}</h5>
            <Link to="/booking">{language === 'fr' ? 'Trouver des soins' : 'Find care'}</Link>
            <Link to="/booking">{language === 'fr' ? 'Comment ça marche' : 'How it works'}</Link>
            <Link to="/booking">{language === 'fr' ? 'Solutions IA' : 'AI solutions'}</Link>
            <Link to="/blog">Blog</Link>
          </div>

          <div>
            <h5>{language === 'fr' ? 'Pour les professionnels' : 'For professionals'}</h5>
            <a href="/connexion">{language === 'fr' ? 'Portail clinicien' : 'Clinician portal'}</a>
            <Link to="/devenir-prestataire">{language === 'fr' ? 'Devenir prestataire' : 'Become a provider'}</Link>
            <a href="mailto:info@knowmediq.ca">{language === 'fr' ? 'Nous écrire' : 'Contact us'}</a>
            <a href="tel:855-904-5898">855-904-5898</a>
          </div>

          <div>
            <h5>{language === 'fr' ? 'Entreprise' : 'Company'}</h5>
            <Link to="/">{language === 'fr' ? 'Accueil' : 'Home'}</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/booking">{language === 'fr' ? 'Réserver' : 'Book care'}</Link>
            <Link to="/services/soins-a-domicile">{language === 'fr' ? 'Soins à domicile' : 'Home care'}</Link>
          </div>

          <div>
            <h5>{language === 'fr' ? 'Légal' : 'Legal'}</h5>
            <a href="/privacy">{language === 'fr' ? 'Politique de confidentialité' : 'Privacy policy'}</a>
            <a href="/terms">{language === 'fr' ? 'Conditions d’utilisation' : 'Terms of use'}</a>
            <a href="/privacy">{language === 'fr' ? 'Conformité PIPEDA' : 'PIPEDA compliance'}</a>
            <a href="/contact">{language === 'fr' ? 'Accessibilité' : 'Accessibility'}</a>
          </div>
        </div>

        <div className="km-footer__bottom">
          <p>
            © 2026 KnowMediQ. {language === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}
          </p>
          <p>
            {language === 'fr'
              ? 'KnowMediQ s’engage à protéger la confidentialité des informations de santé et à travailler avec des prestataires vérifiés.'
              : 'KnowMediQ protects health information privacy and works with verified care providers.'}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
